module.exports = __webpack_public_path__ + "static/img/jsjs2.fb15b0a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/article/jsjs2.jpeg
// module id = KCvq
// module chunks = 0